module.exports = __webpack_public_path__ + "img/taketomi_1.67aa90d3.jpg";